/* eslint-disable */
import useJwt from '@/auth/jwt/useJwt'
import navMenuItems1 from "@/navigation/vertical";
/**
 * Return if user is logged in
 * This is completely up to you and how you want to store the token in your frontend application
 * e.g. If you are using cookies to store the application please update this function
 */
// eslint-disable-next-line arrow-body-style
export const isUserLoggedIn = () => {
  return localStorage.getItem('userData')
}

export const getUserData = () => JSON.parse(localStorage.getItem('userData'))

/**
 * This function is used for demo purpose route navigation
 * In real app you won't need this function because your app will navigate to same route for each users regardless of ability
 * Please note role field is just for showing purpose it's not used by anything in frontend
 * We are checking role just for ease
 * NOTE: If you have different pages to navigate based on user ability then this function can be useful. However, you need to update it.
 * @param {String} userRole Role of user
 */
export const getHomeRouteForLoggedInUser = (userRole, access) => {
  console.log('userRole en utils', userRole)
  console.log('access en utils', access)

  if (Array.isArray(access) && access.length > 0) {
    for (const item of access) {
      if (item.route) {
        return item.route;
      }

      if (Array.isArray(item.children) && item.children.length > 0) {
        const childWithRoute = item.children.find(child => child.route);
        if (childWithRoute) {
          return childWithRoute.route;
        }
      }
    }
  }

  return 'error-404';
}

export const getUserAcessPermissions = (role) => {
  let permissions = [];
  switch (role) {
    case "Administrador":
      permissions = [
        1, 2, 4, 9, 10, 11, 16, 17, 19, 29, 21, 22, 24
      ];
      break;
  }

  return permissions;
};


export const validateAccess = (route, permissions, role) => {
  let hasAccess = false;
  navMenuItems1.forEach((element) => {
    if (element.route && element.route.id == route.id) {
      if (permissions.indexOf(element.id) != -1) {
        hasAccess = true;
      }
    } else {
      if (element.children) {
        element.children.forEach((child) => {
          if (child.route && child.route.id == route.id) {
            if (permissions.indexOf(child.id) != -1) {
              hasAccess = true;
            }
          }
        });
      }
    }
  });
  return hasAccess;
};